import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"

//pass new generated access token here
// const token = localStorage.getItem('token') || '';

//apply base url for axios

const hostname = window.location.hostname
console.log(hostname, "from api_helper")
let API_URL = "https://cmsapi-stag.tnsed.com"
// const API_URL = "http://127.0.0.1:8000";

if (hostname === "tncms.tnsed.com") {
  API_URL = "https://cmsapi.tnsed.com"
}

const axiosApi = axios.create({
  baseURL: API_URL,
  // headers : {
  //  'Content-Type': 'application/json'
  // }
})

// if(token)
//   axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export const HandleException = err => {
  console.log(err, "from handleException")
  // const history = useNavigate();
  try {
    if (err?.response?.data) {
      let { data, status, statusText, config, headers, request } = err.response
      if (status == 400) {
        toast.error(data?.message)
        return data
      } else if (status == 401) {
        if (localStorage.getItem("authUser")) {
          toast.error("You Session Time out")
          setTimeout(() => {
            localStorage.clear()
            window.location.href = "/"
          }, 2000)
        } else {
          // window.location.href = "/pages-401";
          toast.error("Unauthorized Response!")
        }
      } else if (status == 404) {
        toast.error("Page Not Found")
      } else {
        toast.error(`status  retruns ${data?.message}`)
      }
    } else {
      toast.error("Something went wrong check or check your internet")
    }
  } catch (error) {
    toast.error("Someting went wrong or check your internet")
  }
  return {}
}

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

axiosApi.interceptors.request.use(
  config => {
    let token = localStorage.getItem("token") || ""
    if (typeof window !== "undefined") {
      // hostname = window.location.hostname;
    }
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data)
    .catch(err => HandleException(err))
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => HandleException(err))
}

export async function post2(url, data) {
  return axiosApi
    .post(url, data)
    .then(response => response.data)
    .catch(err => HandleException(err))
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => HandleException(err))
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(err => HandleException(err))
}
